"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Button = require("../../components/form/Button");

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProjectSuccessPanel = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ProjectSuccessPanel, _Component);

  function ProjectSuccessPanel() {
    (0, _classCallCheck3.default)(this, ProjectSuccessPanel);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectSuccessPanel.__proto__ || (0, _getPrototypeOf2.default)(ProjectSuccessPanel)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectSuccessPanel, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.resetState();
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "col col-xs-12 text-center" },
        _react2.default.createElement("i", { className: "icon-mp-ok create-ad-success-icon" }),
        _react2.default.createElement(
          "div",
          { className: "col-xs-8 col-xs-offset-2" },
          _react2.default.createElement(
            "h1",
            { className: "h3 title-js" },
            "Projekti on p\xE4ivitetty."
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "col-xs-12" },
          _react2.default.createElement(
            "div",
            { className: "row" },
            _react2.default.createElement(
              "p",
              null,
              _react2.default.createElement("br", null),
              _react2.default.createElement("br", null)
            ),
            _react2.default.createElement(
              "div",
              { className: "col-xs-12" },
              _react2.default.createElement(_Button2.default, {
                text: "Projektiin",
                additionalClasses: "button-set-width button-inverse",
                onClick: this.handleSearchButtonClick.bind(this)
              })
            )
          )
        )
      );
    }
  }, {
    key: "handleSearchButtonClick",
    value: function handleSearchButtonClick() {
      this.props.resetState();
      var project = this.props.project;

      var route = "/projekti/" + project.id;
      this.props.pushRoute(route);
    }
  }]);
  return ProjectSuccessPanel;
}(_react.Component), _class.propTypes = {
  pushRoute: _react.PropTypes.func.isRequired,
  resetState: _react.PropTypes.func.isRequired,
  project: _react.PropTypes.object
}, _temp);
exports.default = ProjectSuccessPanel;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/projects/ProjectSuccessPanel.js
 ** module id = 484
 ** module chunks = 0
 **/